import { connect } from 'react-redux'
import { DraftsTable } from '../../components/GenericProductConfig/DraftsTable'
import * as actions from './actions.es6'

const mapStateToProps = state => ({
  partnerDrafts: state.genericProducts.partnerDrafts,
  partnerDraftsLoader: state.genericProducts.partnerDraftsLoader,
  partnerDraftsError: state.genericProducts.partnerDraftsError
})

const mapDispatchToProps = dispatch => ({
  onFetch: () => dispatch(actions.fetchPartnerDraftsRequest()),
  onReview: jobId => dispatch(actions.reviewDraftRequest(jobId))
})

export const DraftsTableContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(DraftsTable)
